export const PROCESSING = 'PROCESSING';
export const CANCELED = 'CANCELED';
export const DOW_JONES_FAILED = 'DOW_JONES_FAILED';
